import Image from "react-bootstrap/Image";
import logo from "./Images/KeenOnSkin-Logo.png";

function App() {
	return (
		<>
			<div className='container-fluid'>
				<header>
					<div>
						<div>
							<a target='_blank' href='https://lexicon.vevy.com/keenonskin'>
								<Image
									src={logo}
									alt='Vevy Switzerland Logo'
									className='img-responsive center-block'
								/>
							</a>
						</div>
					</div>

					<div>
						<div>
							<h4>
								KEEN ON SKIN is a tool for scientific dissemination,
								<br /> supplement of Lexicon Vevy Europe Skin Care Instant
								Reports,
								<br /> based on specific skin topics.
								<br />
								<br />
								<span className='medium'>
									LINK TO{" "}
									<a
										target='_blank'
										href='https://lexicon.vevy.com/keenonskin'
										title='KEEN ON SKIN'
									>
										{" "}
										KEEN ON SKIN
									</a>{" "}
									PUBLICATION'S INDEX
								</span>
								<br />
							</h4>
						</div>
					</div>
					<br />
					<br />
					<div className='orangeBord horizzontal'>
						<div>
							Vevy Europe S.p.A.
							<br />
							via Semeria, 16A - 16131 Genova - Italia
						</div>
						<div>Tel +39 010 5225 11</div>
					</div>
				</header>
			</div>
		</>
	);
}

export default App;
